import api from "./api";

const BASE = "/IoTDevice";

const unwrap = (res) => res?.data ?? null;

export const getDeviceByTracking = async (trackingNumber) =>
    unwrap(await api.get(`${BASE}/tracking/${encodeURIComponent(trackingNumber)}`));

export const getDevicePosition = async (deviceId) =>
    unwrap(await api.get(`${BASE}/${deviceId}/position`));

export const getDeviceOnlineStatus = async (deviceId) =>
    unwrap(await api.get(`${BASE}/${deviceId}/online`));

export const getDeviceRoute = async (deviceId) =>
    unwrap(await api.get(`${BASE}/${deviceId}/route`));

export default {
    getDeviceByTracking,
    getDevicePosition,
    getDeviceOnlineStatus,
    getDeviceRoute,
};